// extracted by mini-css-extract-plugin
export default {"calendar":"Calendar_calendar__vKx+D","activitiesColorContainer":"Calendar_activitiesColorContainer__GZHsl","activitiesColor":"Calendar_activitiesColor__ppgsB"};